export const WHEN_TO_USE = `Purpose: set the context components of a dataset traversal — the
components the traversal starts from.

Trigger: ONLY when the user explicitly asks for the current traversal or viewpoint (the user
may call it a "view") to start from a set of components, or from all components or a
specific component of its start type. Examples: "set the context to Salesforce", "run this
viewpoint from the HR applications instead", "start the traversal from all applications",
"add Salesforce to the context", "remove Finance from the context", "I want to see this same
view for Finance". A request to show or see components is not this trigger.

After the call: confirm the new context in one sentence, by component name.`;

export const TRAVERSAL_CONTEXT_DESCRIPTION = `'datasets' — the datasets this tool can
change, each showing its own relationships from its own context components.

Only these can be changed. Two kinds of dataset are deliberately absent: kinds this tool
does not handle at all, and datasets the user has hidden from the visualization, which are
read-only here exactly as they are in the UI. So if the user seems to mean a dataset that
is not listed, do not reach for the nearest one that is — say you cannot change it, that a
hidden dataset has to be brought back into view first, and ask which one they mean.

Each entry has:
- 'datasetId' — copy it back verbatim as 'datasetId' to name the dataset to change. It stays
  the same for the dataset's whole lifetime, including across the change this tool makes;
- 'viewpointName' — its saved viewpoint's name, null when the dataset is ad-hoc;
- 'startComponentType' — the component type its context components are, and the only type
  they can be; null when the dataset starts from several types, which rules out 'allOfType';
- 'contextComponentCount' — how many components the dataset starts from right now;
- 'contextComponents' — the components the dataset starts from, by id and name, but only
  the first 50 of them. This is the selection the user is looking at: use it to resolve
  "this" and "these". A 'name' of null only means the name is not loaded — keep the entry
  and pass its id back unchanged.

'contextComponents' is the complete base to work from for "add X" and "remove Y" only while
'contextComponentCount' is 50 or less. Above that the list is cut short, and since the
payload replaces the whole context, sending it back would silently drop everything you
cannot see — so for "add X" or "remove Y" on such a dataset, say the context is too large
to edit that way and that the user can adjust it in the context dropdown. Replacing the
context outright with components the user names stays fine at any size, as does 'allOfType'.

Resolve a component the user names that is not in 'contextComponents' to an id with your
data tools before calling.`;
